import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import ResponsiveImage from 'components/util/ResponsiveImage'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import runMobileScreen from 'images/app-page/data-to-make-you-better/screens/mobile/run.png'
import rideMobileScreen from 'images/app-page/data-to-make-you-better/screens/mobile/ride.png'
import runDesktopScreen from 'images/app-page/data-to-make-you-better/screens/desktop/run.png'
import rideDesktopScreen from 'images/app-page/data-to-make-you-better/screens/desktop/ride.png'
import styles from './_dataToMakeYouBetter.css'

const screens = {
  mobile: {
    fitness: runMobileScreen,
    walk: runMobileScreen,
    run: runMobileScreen,
    hike: runMobileScreen,
    ride: rideMobileScreen,
  },
  desktop: {
    fitness: runDesktopScreen,
    walk: runDesktopScreen,
    run: runDesktopScreen,
    hike: runDesktopScreen,
    ride: rideDesktopScreen,
  },
}

function DataToMakeYouBetter (props) {
  const { slug } = props.site

  const mobileScreen = screens.mobile[slug] || screens.mobile.fitness
  const desktopScreen = screens.desktop[slug] || screens.desktop.fitness

  return (
    <div className={styles.dataToMakeYouBetter}>
      <div className={styles.content}>
        <Title>
          <FormattedMessage id='appPage.dataToMakeYouBetter.title' defaultMessage={`The Data To\n Make You\n Better`} />
        </Title>
        <Caption>
          <FormattedMessage
            id='appPage.dataToMakeYouBetter.caption'
            defaultMessage='Break down your performance with easy-to-read charts and graphs.'
          />
        </Caption>
      </div>
      <div className={styles.screen}>
        <ResponsiveImage medium={desktopScreen} src={mobileScreen} />
      </div>
    </div>
  )
}

DataToMakeYouBetter.propTypes = {
  site: PropTypes.object,
}

export default DataToMakeYouBetter



// WEBPACK FOOTER //
// ./src/components/app-page/data-to-make-you-better/index.jsx